import { render, staticRenderFns } from "./PrintWay.vue?vue&type=template&id=2e8f6d34&scoped=true&"
import script from "./PrintWay.vue?vue&type=script&lang=js&"
export * from "./PrintWay.vue?vue&type=script&lang=js&"
import style0 from "./PrintWay.vue?vue&type=style&index=0&id=2e8f6d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f6d34",
  null
  
)

export default component.exports